import { useState } from "react";
import { Card } from "@/components/ui/card";
import { StockTable } from "../StockTable";

interface InventoryManagerProps {
  isInventoryActive: boolean;
  stockItems: any[];
  buttonVisibility: any;
  refetch: () => void;
  onRestockClick: (item: any) => void;
  onReturnClick: (item: any) => void;
}

export const InventoryManager = ({
  isInventoryActive,
  stockItems,
  buttonVisibility,
  refetch,
  onRestockClick,
  onReturnClick,
}: InventoryManagerProps) => {
  if (isInventoryActive) {
    return null;
  }

  return (
    <Card className="p-0 bg-white shadow-lg border border-siby-100">
      <StockTable
        items={stockItems}
        onAddToCart={() => {}}
        refetch={refetch}
        onRestockClick={onRestockClick}
        onReturnClick={onReturnClick}
        buttonVisibility={buttonVisibility}
      />
    </Card>
  );
};